import { ParameterType } from '@/study-search/enums';
import { SpecialProgrammesFilterOptionValue } from '@studyportals/search-filters';
import { TitleBase } from './TitleBase';

export default class TitleSpecialProgrammesErasmusMundus extends TitleBase {
	protected canHandle(): boolean {
		return (
			this.indexableFilters.length === 1 &&
			this.indexableFilters.some(
				(_) =>
					_.type === ParameterType.SPECIAL_PROGRAMMES &&
					(_.values[0] as SpecialProgrammesFilterOptionValue) === SpecialProgrammesFilterOptionValue.ERASMUS_MUNDUS
			)
		);
	}

	protected getPageTitle(): string {
		return `Erasmus Mundus joint ${this.titlePortalType}`;
	}

	protected getMetaTitle(): string {
		return `Discover ${this.totalSearchResults} Erasmus Mundus joint ${this.titlePortalType}`;
	}

	protected getMetaDescription(): string {
		return (
			`Find top Erasmus Mundus joint ${this.titlePortalType} worldwide. Study with global partners for a brighter future. ` +
			`Explore now with ${this.portalName}.`
		);
	}
}
